import { render } from "./TheNavegation.vue?vue&type=template&id=17004495&scoped=true"
const script = {}

import "./TheNavegation.vue?vue&type=style&index=0&id=17004495&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17004495"]])

export default __exports__